<template>
  <div class="order-list">
    <van-nav-bar
      title="电子发票"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="van-address-edit">
      <div class="van-address-edit__fields">
        <div v-if="data && data.length > 0">
          <template v-for="row in data">
            <div class="order-list-card">
              <van-panel :key="row.id" desc="描述信息" status="状态">
                <div style="padding: 0px 18px;">
                <span class="order-list-item">
                  {{ row.tax_num || row.mobile }}
                </span>
                </div>
                <template #header>
                  <van-row style="padding: 10px 10px;">
                    <van-col :span="17">
                        <span class="order-code">
                      &nbsp;  {{ row.payer }}
                        </span>
                    </van-col>
                    <van-col :span="7" style="text-align: right">
                        <span class="order-price">
                          ￥{{ row.amount | toThousandFilter }}
                        </span>
                    </van-col>
                  </van-row>
                </template>
                <template #footer>
                  <van-row>
                    <van-col :span="2">
                      <van-icon name="clock" class="order-list-clock" />&nbsp;
                    </van-col>
                    <van-col :span="17">
                        <span class="order-list-date">
                          {{ row.last_modify_time }}
                        </span>
                    </van-col>
                    <van-col :span="5" style="text-align: right;">
                      <van-tag :type="Utils.getConstColor(row.status, 'INVOICE_STATUS')">
                        {{ row.status | fmConst('INVOICE_STATUS') }}
                      </van-tag>
                    </van-col>
                  </van-row>
                </template>
              </van-panel>
            </div>
          </template>
        </div>
        <div v-else>
          <van-col :span="24" style="text-align: center; color: #c3c3c3">
            <span>暂无数据</span>
          </van-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getInvoiceList } from '@/api/wx-fwh'
export default {
  name: 'WxOrderList',
  data() {
    return {
      data: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      getInvoiceList({
        sort: 'id',
        order: 'desc'
      }).then(resp => {
        this.data = resp.rows || []
      })
    }
  }
}
</script>

<style scoped>
  .order-list {
    color: #323233;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  }
  .order-list-card {
    margin-top: 20px;
  }
  .order-list-item {
    font-size: 12px;
    color: gray;
  }
  .order-list-date {
    font-size: 14px;
  }
  .order-list-clock {
    color: skyblue;
    font-size: 18px;
  }
  .order-code {
    font-size: 14px;
  }
  .order-price {
    color: darkorange;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxfwh/apply-invoice/wx-invoice-list.vue